/**
 * The Landmate mark: a roofline and a door on a ground line, inside a rounded
 * square. Inline so it follows the color scheme (the fills are CSS tokens),
 * and decorative — the visible word "Landmate" next to it is the name.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 32 32" width="32" height="32" aria-hidden="true" focusable="false">
      <path
        className="logo-mark-fg"
        transform="translate(0 17)"
        d="M7 14a4 4 0 0 1 0-8 5 5 0 0 1 9-1 4 4 0 1 1 3 9H7Z"
      />
      <path
        className="logo-mark-fg-stroke"
        transform="translate(0 -12)"
        d="M8 21 16 15l8 6M10 20v10h12V20M14 30v-6h4v6"
      />
    </svg>
  );
}

export function Wordmark() {
  return (
    <span className="wordmark">
      <LogoMark className="wordmark-mark" />
      <span className="wordmark-text">Landmate</span>
    </span>
  );
}
